export const codeMirrorConfig = {
  foldGutter: true,
  tabSize: 2,
  dragDrop: false,
  keyMap: 'sublime',
  gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter'],
  lineNumbers: true,
  showCursorWhenSelecting: true,
  autoCloseBrackets: true,
  matchBrackets: true,
  lineWrapping: true,
}
